'use client';
import React from 'react';

export interface UseResizeObserverOptions extends ResizeObserverOptions {
  enabled?: boolean;
}

export function useResizeObserver<T extends HTMLElement = HTMLElement>(
  ref: React.RefObject<T | null>,
  callback: (entry: ResizeObserverEntry) => void,
  options: UseResizeObserverOptions = {},
): void {
  const { box, enabled = true } = options;
  const callbackRef = React.useRef(callback);
  callbackRef.current = callback;

  React.useEffect(() => {
    if (!enabled || typeof ResizeObserver === 'undefined') return;
    const element = ref.current;
    if (!element) return;

    const observer = new ResizeObserver((entries: ResizeObserverEntry[]) => {
      const entry = entries[0];
      if (entry) callbackRef.current(entry);
    });

    observer.observe(element, { box });
    return () => observer.disconnect();
  }, [ref, enabled, box]);
}

export default useResizeObserver;
